<div class="popup-wrapper">
  <router-outlet />
</div>
